import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import TourLogo from '../assets/img/TourLogo.png';

function Welcome() {
  const [isVisible, setIsVisible] = useState(true);
  const navigate = useNavigate();

  const handleHomeClick = () => {
    setIsVisible(false); // Hide the Welcome page
    navigate('/'); // Navigate to the home route
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Smoothly scroll to the top
  };

  // Ensure component updates correctly
  console.log("Welcome component isVisible:", isVisible);

  // Render nothing if the component should be hidden
  if (!isVisible) {
    return null;
  }

  return (
    <><div className="fade-in">
      <h2 className="WelcomeTXT">
        Welcome To Mystic Albania!
        <hr/>
        <br />
        Your guide towards amazing vacations in our gorgeous ALBANIA
      </h2>
      <hr/>
      <h3 >Click here to continue !</h3>
      <div onClick={handleHomeClick} style={{ cursor: 'pointer' }}>
        <img
          alt="Tour Logo"
          src={TourLogo}
          width="200"
          height="200"
          className="d-inline-block align-top"
        />
      </div>
      </div>
    </>
  );
}

export default Welcome;
